import { forwardRef } from "react";
import clsx from "clsx";
import type { TooltipArrowSide, TooltipSurfaceProps } from "./types";

const SURFACE_CLASS =
  "pointer-events-none absolute rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-white shadow-lg";

const ARROW_CLASS = "absolute h-2 w-2 -translate-x-1/2 rotate-45 bg-slate-900";

const ARROW_SIDE_CLASS: Record<TooltipArrowSide, string> = {
  top: "bottom-full translate-y-1/2",
  bottom: "top-full -translate-y-1/2",
};

export const TooltipSurface = forwardRef<HTMLSpanElement, TooltipSurfaceProps>(
  function TooltipSurface(
    { children, arrowSide, arrowOffsetLeft, className, style },
    ref,
  ) {
    return (
      <span
        ref={ref}
        role="tooltip"
        className={clsx(SURFACE_CLASS, className)}
        style={style}
      >
        {children}
        {arrowSide && (
          <span
            className={clsx(
              ARROW_CLASS,
              ARROW_SIDE_CLASS[arrowSide],
              arrowOffsetLeft === undefined && "left-1/2",
            )}
            // Keep the arrow inside the surface even when the target sits at a viewport edge.
            style={
              arrowOffsetLeft !== undefined
                ? { left: `clamp(8px, ${arrowOffsetLeft}px, calc(100% - 8px))` }
                : undefined
            }
          />
        )}
      </span>
    );
  },
);
